export function mentionLabel(mention) {
  if (mention.kind === "document_arrival") return "A new document";
  const sender = mention.sender;
  if (!sender) return "A former teammate";
  return `${sender.firstName || ""} ${sender.lastName || ""}`.trim() || "A teammate";
}

export function mentionVerb(mention) {
  if (mention.kind === "assignment") return "assigned you to";
  if (mention.kind === "document_arrival") return "arrived on";
  return "mentioned you on";
}
